"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutOutlined = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.LogoutOutlined = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M7.25 1.5C7.66421 1.5 8 1.83579 8 2.25C8 2.66421 7.66421 3 7.25 3H3V13H7.25C7.66421 13 8 13.3358 8 13.75C8 14.1642 7.66421 14.5 7.25 14.5H2.75C2.05964 14.5 1.5 13.9404 1.5 13.25V2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H7.25Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M10.7448 4.99463C11.0377 4.70174 11.5126 4.70174 11.8055 4.99463L14.2803 7.46951C14.3738 7.56291 14.4374 7.67483 14.4712 7.79344C14.4738 7.80268 14.4763 7.81196 14.4786 7.82128C14.4848 7.84667 14.4896 7.87232 14.4931 7.89812C14.4945 7.90804 14.4956 7.91799 14.4966 7.92795C14.5001 7.9647 14.5009 8.00166 14.499 8.03851C14.4891 8.23466 14.4038 8.41093 14.2716 8.53896L11.8055 11.005C11.5126 11.2979 11.0377 11.2979 10.7448 11.005C10.4519 10.7121 10.4519 10.2373 10.7448 9.94438L11.9392 8.75L5.75 8.75C5.33579 8.75 5 8.41421 5 8C5 7.58579 5.33579 7.25 5.75 7.25L11.9395 7.25L10.7448 6.05529C10.4519 5.7624 10.4519 5.28753 10.7448 4.99463Z", fill: colors[0] }));
    },
    name: 'logout_outlined',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M7.25 1.5C7.66421 1.5 8 1.83579 8 2.25C8 2.66421 7.66421 3 7.25 3H3V13H7.25C7.66421 13 8 13.3358 8 13.75C8 14.1642 7.66421 14.5 7.25 14.5H2.75C2.05964 14.5 1.5 13.9404 1.5 13.25V2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H7.25Z', 'M10.7448 4.99463C11.0377 4.70174 11.5126 4.70174 11.8055 4.99463L14.2803 7.46951C14.3738 7.56291 14.4374 7.67483 14.4712 7.79344C14.4738 7.80268 14.4763 7.81196 14.4786 7.82128C14.4848 7.84667 14.4896 7.87232 14.4931 7.89812C14.4945 7.90804 14.4956 7.91799 14.4966 7.92795C14.5001 7.9647 14.5009 8.00166 14.499 8.03851C14.4891 8.23466 14.4038 8.41093 14.2716 8.53896L11.8055 11.005C11.5126 11.2979 11.0377 11.2979 10.7448 11.005C10.4519 10.7121 10.4519 10.2373 10.7448 9.94438L11.9392 8.75L5.75 8.75C5.33579 8.75 5 8.41421 5 8C5 7.58579 5.33579 7.25 5.75 7.25L11.9395 7.25L10.7448 6.05529C10.4519 5.7624 10.4519 5.28753 10.7448 4.99463Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
